import React from 'react';
import queryString from 'query-string';
import withRouter from '/src/components/misc/withRouter';
import reservationsModel from '../../../../model/reservations';
import Loading from '../misc/Loading';

class ReservationsList extends React.Component {
  constructor(props) {
    super(props);

    this.limit = 20;
    this.offset = 0;
    this.total = null;
    this.company = 'MMC NORGE AS';
    this.path = '/mmc';

    this.state = {
      reservations: [],
      messages: {}
    };

    this.setOffset = this.setOffset.bind(this);
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    const location = this.props.location.pathname;
    if (location.includes('/hbi')) {
      this.company = 'HBI NORGE AS';
      this.path = '/hbi';
    }
    const query = queryString.parse(this.props.location.search);
    if (query) {
      if (query.page && query.page > 0) {
        this.offset = (query.page - 1) * this.limit;
      }
    }

    this.fetchReservations(this.offset, this.limit, this.filter, this.company);
  }

  fetchReservations(offset, limit, filter, company) {
    document.title = `Admin - Reservasjoner - ${this.company}`;
    this.setState({
      reservations: []
    }, () => {
      reservationsModel.all(offset, limit, filter, company).then(([reservations, total]) => {
        this.total = total;
        this.setState({
          reservations: reservations
        });
      }).catch((error) => {
        console.error(error);
        this.setState({
          messages: {
            error: {
              title: 'Feil ved henting av reservasjoner',
              message: 'Er services startet og tilgjengelig?'
            }
          }
        });
      });
    });
  }

  setOffset(e, offset) {
    e.preventDefault();

    this.props.history.replace({
      pathname: `/reservations${this.path}`,
      search: queryString.stringify({
        page: Math.floor(offset / this.limit) + 1
      })
    });

    this.offset = offset;
    this.fetchReservations(this.offset, this.limit, this.filter, this.company);
  }

  gotoReservation(id) {
    this.props.history.push(`/reservations/${id}`);
  }

  printMessages() {
    if (this.state.messages.error) {
      return <div className="alert alert-danger"><strong>{this.state.messages.error.title}</strong> {this.state.messages.error.message}</div>;
    }
  }

  printToolbar() {
    if (this.state.messages.error) {
      return;
    }

    return (
      <div className="btn-toolbar" role="toolbar">
        <button
          onClick={() => reservationsModel.downloadExport(this.company)}
          className="btn btn-default"
        >
          Eksporter alle (CSV)
        </button>
      </div>
    );
  }

  printPager() {
    if (!this.state.reservations.length) {
      return;
    }

    if (!this.total || this.total <= this.limit) {
      return;
    }

    const pages = Math.ceil(this.total / this.limit);
    const offsets = [];

    for (let i = 0; i < pages; i++) {
      offsets.push(i * this.limit);
    }

    const pagingSpan = 10;
    const currentPageNumber = (this.offset > 0) ? ((this.offset / this.limit) + 1) : this.offset;
    const pagingMinValue = (currentPageNumber > pagingSpan) ? (currentPageNumber - pagingSpan) : 0;
    const pagingMaxValue = pagingMinValue + pagingSpan;

    const lastOffset = offsets[offsets.length - 1];

    if (this.total && this.total > this.limit) {
      return <ul className="pagination">
        <li className={this.offset > 0 ? '' : 'disabled'}>
          <a href="#" onClick={(e) => this.setOffset(e, 0)} aria-label="First">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        {offsets.map((offset, i) => {
          if (i < pagingMaxValue && i >= pagingMinValue) {
            return <li key={i} className={this.offset === offset ? 'active' : ''}>
              <a href="#" onClick={(e) => this.setOffset(e, offset)}>
                {i + 1}
              </a>
            </li>;
          } else if (i === pagingMaxValue) {
            return <li key={i}><a onClick={(e) => this.setOffset(e, offset)}> ... </a></li>;
          }
          return '';
        })}

        <li className={(this.offset + this.limit) > this.total ? 'disabled' : ''}>
          <a href="#" onClick={(e) => this.setOffset(e, lastOffset)} aria-label="Last">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>;
    }
  }

  render() {
    if (!this.state.reservations) {
      return (
        <Loading title="Reservasjoner" text="Laster reservasjoner"/>
      );
    }

    return (
      <section>
        <div className="row">
          <div className="col-lg-12">
            <h1 className="page-header">Reservasjoner <small>{this.company}</small></h1>
            {this.printMessages()}
            {this.printToolbar()}
            <br />
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Opprettet</th>
                  <th>Konto</th>
                  <th>Forhandler</th>
                  <th>Telefon</th>
                  <th>Navn</th>
                  <th>Beløp</th>
                </tr>
              </thead>
              <tbody>
                {this.state.reservations.map((reservation, i) => {
                  return (
                    <tr key={i} onClick={() => this.gotoReservation(reservation.id)}>
                      <td>
                        {reservation.queue}
                      </td>
                      <td>
                        {new Date(reservation.created * 1000).toLocaleString('nb-no')}
                      </td>
                      <td>
                        <span>{reservation.make}</span>
                      </td>
                      <td>
                        <span>{reservation.dealerName}</span>
                      </td>
                      <td>
                        <span>{reservation.phone}</span>
                      </td>
                      <td>
                        <span>{reservation.name}</span>
                      </td>
                      <td>
                        <span>{Intl.NumberFormat('nb-NO', {minimumFractionDigits: 0}).format(reservation.amount / 100)},-</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-center">
            {this.printPager()}
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(ReservationsList);
